export enum DataExtractionFormat {
    GEOJSON = 'geojson',
    JSON = 'json',
    SQLITE = 'sqlite',
}
